import actionTypes from '../actions/types';
import actionFactoryTypes from '../actions/actionsFactory/types';

export const INITIAL_STATE = {
  assets: [],
  assetsPathNames: {},
  withdrawLimit: {},
  userCurCoinAsset: {},
  curAssetWithdrawInfo: {},
  withdrawAddressList: [],
};

const handleAssetInfoData = (state, { data }) => {
  const assetsPathNames = {};
  data.forEach(item => {
    assetsPathNames[item.fullName.toLocaleLowerCase().replace(/\s+/g, '')] = item.pathName;
  });
  return { ...state, assetsPathNames };
};

const handleSetAssetsData = (state, { data }) => ({
  ...state,
  assets: Array.isArray(data) ? [...data] : [],
});

const handleUserCurCoinAsset = (state, { data }) => {
  const {
    free, locked, freeze, withdrawing,
  } = data;
  const total = Number(free) + Number(locked) + Number(freeze) + Number(withdrawing);
  return { ...state, userCurCoinAsset: { ...data, total } };
};


export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ASSETS_SUCCESS:
      return handleSetAssetsData(state, action);
    case actionTypes.FETCH_ASSET_PIC:
      return { ...state, assetPics: action.data };
    case actionFactoryTypes.FETCH_ASSET_INFO_SUCCESS:
      return handleAssetInfoData(state, action);
    case actionFactoryTypes.FETCH_WITHDRAW_LIMIT_SUCCESS:
      return {
        ...state,
        withdrawLimit: action.data,
      };
    case actionFactoryTypes.FETCH_ASSET_WITHDRAW_INFO_SUCCESS:
      return {
        ...state,
        curAssetWithdrawInfo: action.data,
      };
    case actionFactoryTypes.FETCH_USER_ASSETS_BY_COIN_SUCCESS:
      return handleUserCurCoinAsset(state, action);
    case actionFactoryTypes.FETCH_WITHDRAW_ADDRESS_SUCCESS:
      return { ...state, withdrawAddressList: action.data };
    case actionFactoryTypes.GET_ASSET_MIN_TRADE_INFO:
      return { ...state, assetMinTradeInfo: action.data };
    default:
      return state;
  }
};
